import { Route, Routes, Navigate } from "react-router-dom";
import { AdminLayout } from "../layouts/admin/AdminLayout";
import { AdminProtectedRoute } from "../components/auth/AdminProtectedRoute";
import { AdminDashboard } from "../pages/admin/Dashboard";
import AdminPayouts from "../pages/admin/Payouts";
import SupportTickets from "../pages/admin/SupportTickets";
import AdminAffiliates from "../pages/admin/Affiliates";
import AdminBrands from "../pages/admin/Brands";
import BrandEmailAutomation from "../pages/admin/BrandEmailAutomation";
import BrandWhiteLabel from "../pages/admin/BrandWhiteLabel";
import AdminAgencyPayouts from "../pages/admin/AgencyPayouts";
import { NotFound } from "../pages/NotFound";
import { AdminAuthProvider } from "../contexts/AdminAuthContext/provider";
import AdminCampaigns from "@/pages/admin/Campaigns";
import AdminFaqManager from "@/components/admin/AdminFaqManager";
import ReleaseNotes from "@/pages/admin/ReleaseNotes";
import MilestoneConfiguration from "@/pages/admin/MilestoneConfiguration";
import BrandRanking from "@/pages/admin/BrandRanking";
import AgencyBlog from "@/pages/admin/AgencyBlog";
import AffiliateRewardConfiguration from "@/pages/admin/AffiliateRewardConfiguration";
import BrandRewardConfiguration from "@/pages/admin/BrandRewardConfiguration";
import AgencyRewardConfiguration from "@/pages/admin/AgencyRewardConfiguration";
import UnifiedRewards from "@/pages/admin/UnifiedRewards";
import AdminSnapshots from "@/pages/admin/AdminSnapshots";
import { AdminInvites } from "@/pages/admin/AdminInvites";
import { TrialOTPs } from "@/pages/admin/TrialOTPs";
import LandingPageAnalytics from "@/pages/admin/LandingPageAnalytics";
import AdminNiches from "@/pages/admin/Niches";
import AdminLeads from "@/pages/admin/Leads";
import SalesTeam from "@/pages/admin/SalesTeam";
import AiSearchCredits from "@/pages/admin/AiSearchCredits";
import BulkInvites from "@/pages/admin/BulkInvites";
import AdminPlans from "@/pages/admin/Plans";
import AdminOnboarding from "@/pages/admin/Onboarding";

export function AdminRoutes() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route
          element={
            <AdminProtectedRoute
              allowedRoles={["ADMIN", "SUPER_ADMIN"]}
              loginPath="/auth/admin/login"
            >
              <AdminLayout />
            </AdminProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="onboarding" element={<AdminOnboarding />} />
          <Route path="payouts" element={<AdminPayouts />} />
          <Route path="agency-payouts" element={<AdminAgencyPayouts />} />
          <Route path="support-tickets" element={<SupportTickets />} />
          <Route path="affiliates" element={<AdminAffiliates />} />
          <Route path="brands" element={<AdminBrands />} />
          <Route path="brand-ranking" element={<BrandRanking />} />
          <Route path="plans" element={<AdminPlans />} />
          <Route path="social-search-credits" element={<AiSearchCredits />} />
          <Route
            path="ai-search-credits"
            element={<Navigate to="../social-search-credits" replace />}
          />
          <Route path="bulk-invites" element={<BulkInvites />} />
          <Route path="niches" element={<AdminNiches />} />
          <Route path="leads" element={<AdminLeads />} />
          <Route path="sales-team" element={<SalesTeam />} />
          <Route path="brand-email-automation" element={<BrandEmailAutomation />} />
          <Route path="brand-white-label" element={<BrandWhiteLabel />} />
          <Route path="campaigns" element={<AdminCampaigns />} />
          <Route path="faq" element={<AdminFaqManager />} />
          <Route path="analytics/snapshots" element={<AdminSnapshots />} />
          <Route path="analytics/landing-page" element={<LandingPageAnalytics />} />
          <Route path="invites">
            <Route path="admin-invites" element={<AdminInvites />} />
            <Route path="trial-otps" element={<TrialOTPs />} />
          </Route>
          <Route path="automations">
            <Route path="release-notes" element={<ReleaseNotes />} />
            <Route
              path="email-automations"
              element={<MilestoneConfiguration />}
            />
            <Route path="agency-blog" element={<AgencyBlog />} />
          </Route>
          <Route path="rewards">
            <Route
              path="management"
              element={<AffiliateRewardConfiguration />}
            />
            <Route
              path="brand-management"
              element={<BrandRewardConfiguration />}
            />
            <Route
              path="agency-management"
              element={<AgencyRewardConfiguration />}
            />
            <Route path="unified" element={<UnifiedRewards />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}
